import { Selector, createSelector } from '@ngrx/store';

import * as LocationRouterSelectors from './locations-router.selector';
import * as RouterStoreSelectors from './router.selector';

import { InstalledApplicationsStoreSelectors } from '../installed-applications';

export const selectBundleId: Selector<object, string | null> = RouterStoreSelectors.selectRouterParam('bundleId');

export const selectDistinctBundleIdentifiersForLocation: Selector<object, string[]> = createSelector(
  LocationRouterSelectors.selectLocationId,
  InstalledApplicationsStoreSelectors.selectAllInstalledApplications,
  (locationId, installedApplications) => {
    return Array.from(
      new Set(
        installedApplications
          .filter((app) => !locationId || app.locationId === locationId)
          .map((app) => app.bundleIdentifier)
          .filter((id): id is string => id != null)
      )
    );
  }
);

export const selectCurrentInstalledApplications = createSelector(
  LocationRouterSelectors.selectLocationId,
  selectBundleId,
  InstalledApplicationsStoreSelectors.selectAllInstalledApplications,
  (locationId, bundleId, installedApplications) => {
    const appStats: Record<string, Record<string, Record<string, number>>> = {};

    const sourceApps = installedApplications.filter(
      (app) => (!locationId || app.locationId === locationId) && (!bundleId || app.bundleIdentifier === bundleId)
    );

    for (const app of sourceApps) {
      const locId = app.locationId;
      const bundleId = app.bundleIdentifier;
      const bundleVer = app.bundleVersion;
      if (locId == null || bundleId == null || bundleVer == null) {
        continue;
      }

      if (appStats[locId] !== undefined) {
        appStats[locId] = {};
      }

      if (appStats[locId][bundleId] !== undefined) {
        appStats[locId][bundleId] = {};
      }

      if (appStats[locId][bundleId][bundleVer] !== undefined) {
        appStats[locId][bundleId][bundleVer] = appStats[locId][bundleId][bundleVer] + 1;
      } else {
        appStats[locId][bundleId][bundleVer] = 1;
      }
    }

    return appStats;
  }
);
